// 先搜助手：简体中文字段。只维护显示文案，不改业务标识、数值或提交内容。

// 助手界面
export const ui = Object.freeze({
  "pcAi.preparingAnswer": "正在准备回答…",
  "pcAi.history": "会话历史",
  "pcAi.newChat": "新对话",
  "pcAi.historyLoading": "历史加载中...",
  "pcAi.noHistory": "暂无历史",
  "pcAi.delete": "删除",
  "pcAi.platformLoading": "平台用户加载中...",
  "pcAi.signingIn": "先搜AI自动登录中...",
  "pcAi.brand": "先搜AI",
  "pcAi.missingIdentity": "平台用户字段缺失",
  "pcAi.missingIdentityHint": "当前用户缺少可用于登录 AI 助手的用户标识。",
  "pcAi.noModels": "无可用模型",
  "pcAi.reload": "重新加载",
  "pcAi.welcome": "先搜 AI 为您服务",
  "pcAi.trace": "AI 执行过程",
  "pcAi.traceFallback": "执行过程",
  "pcAi.sourceCount": "候选来源 {count} 个",
  "pcAi.sourceHint": "候选资料已送入模型上下文，不代表最终引用",
  "pcAi.copy": "复制消息",
  "pcAi.generating": "生成中",
  "pcAi.retry": "重试",
  "pcAi.placeholder": "有什么我能帮您的吗？",
  "pcAi.addAttachment": "添加附件",
  "pcAi.uploadAttachment": "上传图片或 PDF",
  "pcAi.stop": "停止生成",
  "pcAi.send": "发送",
  "pcAi.saving": "正在保存会话...",
  "pcAi.userLoadFailed": "平台用户信息获取失败",
  "pcAi.recommend1": "深圳先搜科技有限公司在哪里？",
  "pcAi.recommend2": "帮我分析这个芯片型号是否可以替代",
  "pcAi.recommend3": "怎样判断一个料号属于哪个品牌？",
  "pcAi.recommend4": "推荐几款常用的国产替代芯片",
  "pcAi.recommend5": "如何根据参数选择合适的电子元器件？",
  "pcAi.recommend6": "帮我整理一份元器件采购询价需求",
  "pcAi.recommend7": "电子元器件选型时需要关注哪些参数？",
  "pcAi.recommend8": "如何识别并修正不规范的元器件料号？",
  "pcAi.recommend9": "帮我比较两个芯片型号的主要区别",
  "pcAi.recommend10": "采购电子元器件时如何降低缺货风险？",
  "pcAi.recommend11": "如何判断不同封装型号能否通用？",
  "pcAi.recommend12": "帮我解释常见芯片参数的含义",
});

// 手机端业务流程：固定界面文案。
export const mobileWorkflow = Object.freeze({
  "mobileAi.loginContinue": "登录后继续使用先搜 AI",
  "mobileAi.freeLimitReached":
    "您已进行了多次搜索。为便于保存本次对话并继续使用先搜 AI，建议您先登录。",
  "mobileAi.loginBenefits": "登录后可保存会话历史，并使用完整的先搜AI功能。",
});

export const speechUi = Object.freeze({
  "speechUi.voiceListFailed": "声音列表加载失败",
  "speechUi.stopVoicePreview": "停止试听",
  "speechUi.previewVoice": "试听声音",
});

export const sharedFlowUi = Object.freeze({
  "aiFeedback.userLoadTimeout": "用户信息加载超时，请点击重试。",
  "aiFeedback.searchGuestQuotaExceeded": "您已进行了多次搜索，建议您登录后继续使用先搜 AI。",
  "aiFeedback.searchGuestLoading": "正在搜索…",
  "aiFeedback.searchGuestFailed": "先搜 AI 暂不可用，请稍后重试。",

  "aiFeedback.renameFailed": "会话名称修改失败",
  "aiFeedback.clearTemporaryChat": "清空临时对话",
  "aiFeedback.guest": "游客",
  "aiFeedback.clearTemporaryChatHint":
    "游客临时对话清空后无法恢复，剩余提问次数不会重置。",
  "aiFeedback.deleteConversationConfirm": "确定删除「{name}」吗？",
});

export const messages = Object.freeze({
  ...sharedFlowUi,
  ...speechUi,
  ...mobileWorkflow,
  ...ui,
});
